import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { gateway } from 'libs/generated-grpc-web';

import { MgPollShortCardElement } from '@app/src/app/elements/MgShortCard/MgPollShortCard';
import { Group } from '@app/src/app/groups/models';
import { GroupsFacadeService } from '@app/src/app/groups/services';
import { ContentEvents } from '@app/src/app/minimal/services/ContentEvents';
import { PollAnswerStateService } from '@app/src/app/minimal/services/PollAnswerState';
import { ContentState } from '@app/src/app/services/ContentState';

import { LongCardBaseClass } from '../LongCardBase/LongCardBaseClass';

@Component({
  selector: 'mg-poll-long-card',
  templateUrl: './PollLongCard.component.html',
  styleUrls: ['./PollLongCard.component.scss'],
})
export class PollLongCardComponent extends LongCardBaseClass implements OnInit {
  @ViewChild('pollShortCard', { static: true })
  pollShortCard?: MgPollShortCardElement;

  content?: gateway.content_views_pb.LongPollCardView.AsObject;

  @Input()
  ignorePermissions: boolean = false;

  constructor(
    public pollAnswerService: PollAnswerStateService,
    public contentEvents: ContentEvents,
    groupFacade: GroupsFacadeService,
    contentState: ContentState,
    router: Router,
  ) {
    super(contentEvents, groupFacade, contentState, router);
  }
  ngOnInit(): void {
    if (this.content && this.content.ownerGroupHash) {
      this.ownerGroupHash.next(this.content.ownerGroupHash);
    }

    if (this.content.hasResponded != -1) {
      this.pollAnswerService.setAnswer(this.contextHash, this.content.hasResponded);
    }
  }

  ngAfterViewInit() {
    this.pollShortCard._applyCurrentAnswerState();
  }

  isOwner(group: Group) {
    return Group.isOwner(group);
  }
}
